import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import YSF from '@neysf/qiyu-web-sdk';
// 引入 Element UI
import ElementUI from 'element-ui';
// 引入样式文件
import 'element-ui/lib/theme-chalk/index.css';
import VueQuillEditor from 'vue-quill-editor'
// 引入quill样式
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
let ysfInstance = null
Vue.prototype.$ysfInit = function () {
  // 必须确保window.YSF已经加载完成
  if (!YSF) {
    return Promise.reject('YSF SDK未加载')
  }
  return YSF.init('afb293753c7546bd0443abf12135872f', {
    sessionInvite: false,
    hidden: 1,
    staffid:'8266655',
  }).then(ysf => {
    ysfInstance = ysf
    // 把实例存到全局
    Vue.prototype.$ysf = ysfInstance
    console.log('ysf初始化成功', ysfInstance)
    return ysfInstance
  }).catch(err => {
    console.error('sdk加载失败', err)
    throw err
  })
}
/**
* 第一个参数是您企业的appKey
* 第二个参数是配置，可选参数及含义见第一部分“基本接入配置-参数说明”表
*/

Vue.use(VueQuillEditor)
Vue.prototype.$bus = new Vue()
export const bus = Vue.prototype.$bus
Vue.config.productionTip = false
Vue.prototype.$baseUrl = 'https://hrxsl.com'
Vue.prototype.$img = function(img) {
  return "https://hr-xinshili.oss-cn-beijing.aliyuncs.com" + img
}
Vue.prototype.$Localimg = function(img) {
  return "https://hrxsl.com/pcImages/" + img
}
Vue.prototype.$imageUrl = "https://hr-xinshili.oss-cn-beijing.aliyuncs.com"  
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
